import { Action } from '@ngrx/store';
import { CurationItemId } from '../../models';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';
import { NodeDependencies } from "@ispm/shared/bpmn/models/node-dependencies";

export enum CurationInfoForPathwaysActionTypes {
  SEARCH_CURATION_ITEM_BY_KEYS = '[Pathways] Fetch Curation Identifier',
  LOAD_PATHWAYS = '[Pathways] Load pathways',
  UPDATE_BPMN_NODES_CURATION_DATA = '[Pathways] Update bpmn curation data',
  UPDATE_BPMN_NODE_SELECTION_DEPENDENCIES_CURATION_DATA = '[Pathways] Update node selection dependencies curation data',
  GET_CURATION_ITEM_BY_ID = '[Pathways] Get curation item by id',
  UPDATE_CLINICAL_TRIALS = '[Pathways] Update clinical trials',
  UPDATE_CURATION_ITEM_ID = '[Pathways] Update curation item id',
  UPDATE_KNOWLEDGE_BASE = '[Pathways] Update knowledge base',
  FETCH_CLINICAL_TRIALS = '[Pathways] Fetch clinical trials',
}

export class SearchCurationItemByKeysAction implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.SEARCH_CURATION_ITEM_BY_KEYS;
}

export class LoadPathwaysAction implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.LOAD_PATHWAYS;
}

export class UpdateBpmnNodesCurationData implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.UPDATE_BPMN_NODES_CURATION_DATA;
  constructor(public payload: { nodes: any}) { }
}

export class UpdateBpmnNodeSelectionDepdendenciesCurationData implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.UPDATE_BPMN_NODE_SELECTION_DEPENDENCIES_CURATION_DATA;
  constructor(public payload: { nodeSelectionDependencies: NodeDependencies }) { }
}

export class GetCurationItemById implements Action {
 readonly type = CurationInfoForPathwaysActionTypes.GET_CURATION_ITEM_BY_ID;
 constructor(public payload: { curationItemId: CurationItemId}) { }
}

export class UpdateClinicalTrialsAction implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.UPDATE_CLINICAL_TRIALS;
  constructor(public payload: { nodeIdToClinicalTrials: any}) { }
}

export class UpdateCurationItemIdAction implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.UPDATE_CURATION_ITEM_ID;
  constructor(public payload: { curationItemId: CurationItemId}) { }
}

export class UpdateKnowledgeBase implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.UPDATE_KNOWLEDGE_BASE;
  constructor(public payload: { knowledgeBase: string}) { }
}

export class FetchClinicalTrialsAction implements Action {
  readonly type = CurationInfoForPathwaysActionTypes.FETCH_CLINICAL_TRIALS;
  constructor(public payload: { bpmnDeploymentIdentifier: BpmnDeploymentIdentifier}) { }
}

export type CurationInfoForPathwaysActions =
  SearchCurationItemByKeysAction |
  LoadPathwaysAction |
  UpdateBpmnNodesCurationData |
  UpdateBpmnNodeSelectionDepdendenciesCurationData |
  GetCurationItemById |
  UpdateClinicalTrialsAction |
  UpdateCurationItemIdAction |
  FetchClinicalTrialsAction |
  UpdateKnowledgeBase
  ;
